export const card3DSecureCode = {
    enabled: false,
    _description:
        'Displays 3d secure code card in the card services section in the bank card settings page and credit card functions page',
};

export const card3DSecureCodeEncryption = {
    enabled: false,
    _description: 'Enables new JWE secured info encryption',
};
